import BaseFormGrid from '../../../components/grids/BaseFormGrid';
import TranslatableText from '../../../components/i18n/TranslatableText';
import { PeriodStatusGridDefs } from '../../../constants/i18n/translations/termDefinitions/accounting';
import { cloneDeep } from 'lodash';
import booleanCellRenderer from '../../../components/grids/cellRenderers/booleanCell.renderer';
import React from 'react';
import usePeriodStatusGrid from './hooks/usePeriodStatusGrid';

const PeriodStatusGrid = () => {
    const {
        canView,
        canCreate,
        canUpdate,
        termSet,
        rowData,
        colDefs,
        handleGridEdits,
        isLoadingData,
        redirectToForm,
    } = usePeriodStatusGrid();

    return (
        <BaseFormGrid
            title={
                (
                    <TranslatableText
                        termKey={PeriodStatusGridDefs.Title}
                        termSet={termSet}
                    />
                ) as unknown as string
            }
            displayGrid={canView}
            isLoading={isLoadingData()}
            rowData={cloneDeep(rowData)}
            useRowDrag={canUpdate}
            sortKey={'sortOrder'}
            columnDefs={colDefs}
            gridClass="full-size-item"
            displayToolbar={true}
            displayCreateNewButton={canCreate}
            displayExportDataButton={true}
            displayResetStateButton={true}
            onCreateNew={redirectToForm}
            onRowClicked={({ data }) => redirectToForm(data)}
            onHandleGridEdits={handleGridEdits}
            frameworkComponents={{
                booleanCellRenderer: booleanCellRenderer,
            }}
        />
    );
};

export default PeriodStatusGrid;
